import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { DevicesTabContext, IDevicesTabContext } from '../../../../../devicesTabState/devicesTabContext';
import style from './DropdownMenu.module.scss';

const DropdownMenu: React.FC = () => {
	const { setDevicesTabSortBy, devicesTabSortBy } = useContext<IDevicesTabContext>(DevicesTabContext);

	return (
		<div className={style.container}>
			<div className={style.resetWrapper}>
				<span className={style.resetBtn} onClick={() => setDevicesTabSortBy('')}>
					<Text translationNameSpace="form" translationKey="resetButton" asFragment={true} />
				</span>
			</div>

			<div className={style.item}>
				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="sortByHardwareIdLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortByHardwareIdA-Z" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setDevicesTabSortBy('HardwareIdA-Z')}
						checked={devicesTabSortBy === 'HardwareIdA-Z'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortByHardwareIdZ-A" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setDevicesTabSortBy('HardwareIdZ-A')}
						checked={devicesTabSortBy === 'HardwareIdZ-A'}
						name="assignmentSort"
					/>
				</label>

				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="sortByTerminalIdLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortByTerminalId1-10" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setDevicesTabSortBy('TerminalId1-10')}
						checked={devicesTabSortBy === 'TerminalId1-10'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortByTerminalId10-1" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setDevicesTabSortBy('TerminalId10-1')}
						checked={devicesTabSortBy === 'TerminalId10-1'}
						name="assignmentSort"
					/>
				</label>
			</div>
		</div>
	);
};

export default DropdownMenu;
